import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import React from "react";
import { FontAwesome } from "@expo/vector-icons";

import { useTheme } from "react-native-paper";

const BackArrow = ({ onPress }: { onPress: () => void }) => {
  const { colors } = useTheme();
  return (
    <TouchableOpacity style={styles.root} onPress={onPress}>
      <FontAwesome name="arrow-left" size={24} color={colors.primary} />
    </TouchableOpacity>
  );
};

export default BackArrow;

const styles = StyleSheet.create({
  root: {
    width: 44,
    height: 44,
    marginLeft: 10,
    marginVertical: 10,
    backgroundColor: "#fff",
    borderRadius: 9,
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,

    elevation: 5,
  },
});
